enum TopicType {
  INDEX_BASED = 'indexBased',
  DATE_BASED = 'dateBased',
  QUIZ = 'quiz',
}

export default TopicType;
